import { render, staticRenderFns } from "./table-list.component.vue?vue&type=template&id=82971690&"
import script from "./table-list.component.vue?vue&type=script&lang=ts&"
export * from "./table-list.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports